import React from 'react';
import styled from 'styled-components';
import { padding } from 'polished';
import { Image } from 'cloudinary-react';

import { IMAGE_LOGO_DARK, IMAGE_LOGO_LIGHT } from 'data/images';

import { buildImgUrl } from 'utils/image/buildImgUrl';

interface LogoProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    dark?: boolean;
    width?: number | string;
    isLink?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ dark = false, width = 250, isLink = true, ...rest }) => {
    const logoImage = dark ? IMAGE_LOGO_DARK : IMAGE_LOGO_LIGHT;

    return (
        <>
            {isLink ? (
                <LogoAnchor href="/" {...rest}>
                    <Image src={buildImgUrl(logoImage)} alt="Totem Logo" width={width} />
                </LogoAnchor>
            ) : (
                <LogoContainer>
                    <Image src={buildImgUrl(logoImage)} alt="Totem Logo" width={width} />
                </LogoContainer>
            )}
        </>
    );
};

interface LogoContainerProps {
    isInline?: boolean;
}
const LogoContainer = styled.div<LogoContainerProps>`
    display: ${(props) => (props.isInline ? 'inline-block' : 'block')};
    text-align: center;
    ${(props) => padding(props.theme.variables.padding * 2.7, props.theme.variables.padding * 1.5)};
`;

interface LogoAnchorProps {
    isInline?: boolean;
    $noPadding?: boolean;
}
const LogoAnchor = styled.a<LogoAnchorProps>`
    display: ${(props) => (props.isInline ? 'inline-block' : 'block')};
    text-align: center;
    ${(props) => padding(props.$noPadding ? 0 : props.theme.variables.padding * 1.5)};
    user-select: none;
`;
